import { MutationTree } from 'vuex';
import {
    SET_MEMBER_GENERAL_INFORMATION,
    SET_MEMBER_PROFILE_DATA,
    SET_COMPANY_DATA,
    ADD_SCHOOL_DATA,
    ADD_COMPANY_DATA,
    EDIT_COMPANY_DATA,
    EDIT_SCHOOL_DATA,
    SET_MEMBER_NETWORK,
    ADD_PHILANTHROPY_DATA,
    SET_PHILANTHROPY_DATA,
    DELETE_COMPANY_DATA,
    DELETE_SCHOOL_DATA,
    SET_CAUSES_DATA,    
  DELETE_PHILANTHROPY_DATA,
    SET_MEMBER_CURRENT_LOCATION,
  SET_MEMBER_LOCATIONS,
    SET_MEMBER_METROPOLITAN_AREAS,
    SET_SUBTYPE_OPPORTUNITIES_LIST,
    SET_COMPANY_NETWORK,
    SET_SCHOOL_NETWORK,
    SET_NONPROFIT_NETWORK,
    SET_METROPOLITAN_AREAS,
    SET_EVENT_TYPES,
    GET_SHORTLISTED_OPPORTUNITY
} from './mutation-types';


import State from './state';
//import { IGeneralInfoOfMember } from '../../../models/interfaces/iGeneralInfoOfMember'
import { GeneralInfoOfMember } from '../../../models/classes/generalInfoOfMember'
import { IMemberProfile } from '../../../models/interfaces/iMemberProfile'
import { MemberProfile } from '../../../models/classes/memberProfile'
import { ILocation } from '../../../models/interfaces/iLocation'
import { Location } from '../../../models/classes/location'
import { Company } from "../../../models/classes/company";
import { Cause } from "../../../models/classes/cause";
import { ICause } from "../../../models/interfaces/iCause";
import { ICompany } from "../../../models/interfaces/iCompany";
import { ISchool } from "../../../models/interfaces/ISchool";
import { School } from "../../../models/classes/school";
import { INetwork } from '../../../models/interfaces/iNetwork'
import { IPhilanthropy } from "../../../models/interfaces/IPhilanthropy";
import { IEditAddPhilanthropyOutput } from "../../../models/interfaces/memberProfile/iEditAddPhilanthropyOutput";
import { Philanthropy } from "../../../models/classes/memberProfile/philanthropy";
import { Month } from "../../../models/classes/memberProfile/month";
import { IMonth } from "../../../models/interfaces/iMonth";
import { SET_KEY } from "../member/mutation-types";
import { IAddEditCausesOutput } from "../../../models/interfaces/IAddCausesOutput";
import { IMemberOrganisationCard } from "../../../models/interfaces/iMemberOrganisationCard";
import { IMetropolitanArea } from "../../../models/interfaces/iMetropolitanArea";
import { IKeyName } from "../../../models/interfaces/IKeyName";
import { MetropolitanArea } from "../../../models/classes/metropolitanArea";
import { KeyName } from "../../../models/classes/KeyName";
import { IDeleteExperienceOutput } from "../../../models/interfaces/memberProfile/iDeleteExperienceOutput";
import { IOpportunity } from '../../../models/interfaces/nonprofitProfile/iOpportunity';

const mutations: MutationTree<State> = {
  async [SET_MEMBER_PROFILE_DATA](state: State, data: IMemberProfile): Promise<any> {
    //debugger;
    const memberProfileData:any = Object.keys(data).reduce((acc, key) => {
      const _acc = acc;
      if (data[key] !== undefined) _acc[key] = data[key];
      return _acc;
        }, {})
    Object.assign(state.profile, memberProfileData);
    },

    [SET_KEY](state: State, key: string): void {
        state.profile.generalInfo = new GeneralInfoOfMember();
        state.profile.generalInfo.key = key;
    },

  [SET_MEMBER_GENERAL_INFORMATION](state: State, data: any): void {
    if (!state.profile.generalInfo)
      state.profile.generalInfo = new GeneralInfoOfMember();

    Object.assign(state.profile.generalInfo, data !== undefined ? data : {});
  },

  [SET_MEMBER_NETWORK](state: State, data: INetwork): void {

    state.profile.network = data;
    },

    [SET_COMPANY_NETWORK](state: State, members: IMemberOrganisationCard[]): void {
        state.profile.network.companyMembers = state.profile.network.companyMembers.concat(members);
    },

    [SET_SCHOOL_NETWORK](state: State, members: IMemberOrganisationCard[]): void {
        state.profile.network.schoolMembers = state.profile.network.schoolMembers.concat(members);
    },

    [SET_NONPROFIT_NETWORK](state: State, members: IMemberOrganisationCard[]): void {
        state.profile.network.nonprofitMembers = state.profile.network.nonprofitMembers.concat(members);
    },
    [GET_SHORTLISTED_OPPORTUNITY](state: State, shortlistedOpportunities: IOpportunity[]): void {
        state.profile.shortlistOpportunitiesList = shortlistedOpportunities;
    },

    [ADD_SCHOOL_DATA](state: State, school: ISchool): void {

        function addDegreesToExitingSchool(): boolean {
            let degreesWasAdded: boolean = false;
            state.profile.schools.forEach((schoolInStore: ISchool) => {
                if (schoolInStore.org.key == school.org.key && schoolInStore.location.key == school.location.key) {
                    schoolInStore.degrees = school.degrees;
                    degreesWasAdded = true;
                }
            })
            return degreesWasAdded;
        }

        if (!addDegreesToExitingSchool()) {
            state.profile.schools.push(school);
        }
        //state.profile.schools = state.profile.schools.sort(function (a, b) {
        //    let result: number;
        //    result = startDate2 - startDate1;
        //    if (result === 0) {
        //        result = a.org.name.localeCompare(b.org.name);
        //    }
        //    return result;
        //})
    },

    [SET_CAUSES_DATA](state: State, causes: ICause[]): void {
        let currentCauses: ICause[] = state.profile.causes;

        if (causes) {          
            state.profile.causes = causes;
        }
        else
        {
            currentCauses.splice(0, currentCauses.length);
        }
    },

    [SET_COMPANY_DATA](state: State, companies: ICompany[]): void {
        state.profile.companies = [...companies]
    },

    [ADD_COMPANY_DATA](state: State, company: ICompany): void {
        function addRolesToExitingCompany():boolean {
            let rolesWasAdded: boolean = false;
            state.profile.companies.forEach((companyInStore: ICompany) => {
                if (companyInStore.org.key == company.org.key && companyInStore.location.key == company.location.key) {
                    companyInStore.roles = company.roles;
                    rolesWasAdded = true;
                }
            })
            return rolesWasAdded;
        }
       

        if (!addRolesToExitingCompany()) {
            state.profile.companies.push(company);
        }

        //state.profile.companies = state.profile.companies.sort(function (a, b) {
        //        let result: number;
        //        let startDate1: any = new Date(a.yearFrom, a.monthFrom.number);
        //        let startDate2: any = new Date(b.yearFrom, b.monthFrom.number);
        //        result = startDate2 - startDate1;
        //        if (result === 0) {
        //            result = a.org.name.localeCompare(b.org.name);
        //        }
        //        return result;
        //    })
    },

    [EDIT_COMPANY_DATA](state: State, company: ICompany) {
        state.profile.companies.forEach(function (val) {
            if (val.org.key == company.org.keyBeforeUpdate && val.location.key == company.location.key) {
                // debugger;
                Object.assign(val, company !== undefined ? company : {});
            }
        })
    },

    [EDIT_SCHOOL_DATA](state: State, school: ISchool) {
        state.profile.schools.forEach(function (val) {
            if (val.org.key == school.org.keyBeforeUpdate && val.location.key == school.location.key) {
                Object.assign(val, school !== undefined ? school : {});
            }
        })
    },
    [SET_PHILANTHROPY_DATA](state: State, philanthropy: IPhilanthropy): void {
        state.profile.philanthropy.forEach(function (val) {
            if (val.memberOrgKey == philanthropy.memberOrgKey) {
                Object.assign(val, philanthropy !== undefined ? philanthropy : {});
            }
        })
    },
    [ADD_PHILANTHROPY_DATA](state: State, philanthropy: IPhilanthropy): void {
        if (philanthropy != null) {
            if (!state.profile.philanthropy) {
                state.profile.philanthropy = [];
            }
            philanthropy.isEditable = true;
            state.profile.philanthropy.push(philanthropy);
        }
    },

    [DELETE_COMPANY_DATA](state: State, company: IDeleteExperienceOutput): void {
        let index = state.profile.companies.findIndex(d => d.org.key === company.orgKey && d.location.key === company.locationKey);
        state.profile.companies.splice(index, 1);
    },
    [DELETE_SCHOOL_DATA](state: State, school: IDeleteExperienceOutput): void {
        let index = state.profile.schools.findIndex(d => d.org.key === school.orgKey && d.location.key === school.locationKey);
        state.profile.schools.splice(index, 1);
    },
    [DELETE_PHILANTHROPY_DATA](state: State, philanthropy: IDeleteExperienceOutput): void {
        let index = state.profile.philanthropy.findIndex(d => d.memberOrgKey === philanthropy.memberOrgKey);
        state.profile.philanthropy.splice(index, 1);
  },

  [SET_MEMBER_LOCATIONS](state: State, locations: ILocation[]): void {

    state.profile.locations = [];

    locations.map((location) => {
      state.profile.locations.push(new Location(location));
    });
  },

  [SET_MEMBER_METROPOLITAN_AREAS](state: State, metropolitanAreas: IMetropolitanArea[]): void {
        if (!metropolitanAreas) {
            return;
        }

        state.profile.metropolitanAreas = [];        
    metropolitanAreas.map((metropolitanAreas) => {
      state.profile.metropolitanAreas.push(new MetropolitanArea(metropolitanAreas));
    });
    },
    [SET_METROPOLITAN_AREAS](state: State, metropolitanAreas: IMetropolitanArea[]): void {
        if (!metropolitanAreas) {
            return;
        }

        state.profile.filterMetropolitanAreas = [];        
    metropolitanAreas.map((metropolitanAreas) => {
      state.profile.filterMetropolitanAreas.push(new MetropolitanArea(metropolitanAreas));
    });
    },
    [SET_SUBTYPE_OPPORTUNITIES_LIST](state: State, subtypeList: IKeyName[]): void {
        if (!subtypeList) {
            return;
        }

        state.profile.subtypOpportunitiesList = [];        
    subtypeList.map((subtypeList) => {
      state.profile.subtypOpportunitiesList.push(new KeyName(subtypeList));
    });
  },

    [SET_EVENT_TYPES](state: State, eventTypes: IKeyName[]): void {
        if (!eventTypes) {
            return;
        }

        state.profile.eventTypes = [];        
    eventTypes.map((eventtype) => {
      state.profile.eventTypes.push(new KeyName(eventtype));
    });
  },
    

  [SET_MEMBER_CURRENT_LOCATION](state: State, key: string): void {
    const locations = state.profile.locations;

    locations.forEach((el: ILocation) => {
      el.isCurrent = el.cityKey === key;
    });
  },

};

export default mutations;


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/member/mutations.ts